import React from "react";
import { L10n, L10nHtml } from "@fidget/common/i18n";
import currentClientContainerStyles from "../../components/dashboard/currentClientContainer/currentClientContainer.css";
import styles from "./emptyChatComponent.css";

const renderLeftBars = () => {
  return (
    <div className={styles["bars-section"]}>
      <div className={styles.bars}>
        <div className={styles.thin} style={{ width: "100px" }} />
        <div className={styles.thick} style={{ width: "180px" }} />
        <div className={styles.thin} style={{ width: "80px" }} />
      </div>
    </div>
  );
};

const renderRightBars = () => {
  return (
    <div className={`${styles["bars-section"]} ${styles.right}`}>
      <div className={`${styles.bars} ${styles.right}`}>
        <div className={styles.thin} style={{ width: "100px" }} />
        <div className={styles.thick} style={{ width: "160px" }} />
        <div className={styles.thin} style={{ width: "80px" }} />
      </div>
      <div className={styles.circle} />
    </div>
  );
};

export const EmptyChatComponent = () => {
  return (
    <div className={currentClientContainerStyles["current-client"]}>
      <div className={currentClientContainerStyles["current-client-chat"]}>
        <div className={currentClientContainerStyles.header}>
          <div className={currentClientContainerStyles["room-label"]}>
            <L10n id={"conversation.placeholder.clientName"} />
          </div>
        </div>
        <div className={styles["chat-box"]}>
          <div className={styles["chat-box-header"]}>
            <L10nHtml id={"conversation.placeholder"} />
            <i className={`icon-arrow ${styles.arrow}`} />
          </div>

          {renderLeftBars()}
          {renderRightBars()}
          {renderLeftBars()}
          {renderRightBars()}
          {renderLeftBars()}
        </div>
      </div>

      <div
        className={[styles.profile, currentClientContainerStyles["current-client-profile"]].join(
          " "
        )}
      >
        <div className={styles["profile-box"]} />
        <div className={styles["profile-box"]} />
        <div className={styles["profile-box"]} />
      </div>
    </div>
  );
};
